<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <div class="note">
              <strong>Ghi chú:</strong>
              <div class="group-content-note">
                <div>Dấu <span class='required'>*</span> là bắt buộc phải điền</div>
                <div>Tài khoản tối thiểu 4, tối đa 100 kí tự bao gồm chữ thường và số</div>
                <div>Mật khẩu tối thiểu 8, tối đa 128 kí tự bao gồm chữ hoa, chữ thường, số và kí tự đặc biệt là 1 trong
                  số kí tự này @$!%*?&
                </div>
                <div>Số điện thoại gồm 10 kí tự và đúng định số điện thoại nước Việt Nam không bao gồm SĐT cố định. Ví
                  dụ: 033*****00 hoặc
                  8433*****00
                </div>
                <div>Email phải đúng định dạng. Ví dụ: demo@com.vn</div>
              </div>
            </div>
          </CCardHeader>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                  <CRow>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                      <BaseSelect :options="rolesSelect.options" :data="rolesSelect.data"
                                  ref="rolesSelect"></BaseSelect>
                    </CCol>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6" v-show="rolesSelect.data.model != 7 && rolesSelect.data.model != 8">
                      <BaseSelect :options="locationSelect.options" :data="locationSelect.data"
                                  ref="locationSelect"></BaseSelect>
                    </CCol>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6" v-if="rolesSelect.data.model == 7 || rolesSelect.data.model == 8">
                      <div class="form-group form-row" ref="locationManagementSelected">
                        <label style="display: inline-flex;" class="col-form-label">Địa bàn quản lý&nbsp;<span
                            class="required">*</span>
                        </label>
                        <multiselect id="locationManagementSelected" v-model="locationManagementSelected.data.model"
                          placeholder="Địa bàn" label="value" track-by="key" :options="locationManagementSelected.options"
                          selectLabel="Chọn" deselectLabel="Bỏ chọn" selectedLabel="Đã chọn" :close-on-select="false"
                          :multiple="true"
                          :class="!(locationManagementSelected.data.validator ? locationManagementSelected.data.validator.isValid : true) ? 'input-error' : ''">
                          <span slot="noResult">Không có dữ liệu tương ứng!</span>
                          <span slot="noOptions">Danh sách rỗng!</span>
                        </multiselect>
                        <!-- <span class="col-sm-3"></span> -->
                        <div class="valid-error"
                          v-show="!(locationManagementSelected.data.validator ? locationManagementSelected.data.validator.isValid : true)">
                          {{ locationManagementSelected.data.validator ? locationManagementSelected.data.validator.errorMessage
                            :
                            "" }}
                        </div>
                      </div>
                    </CCol>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput :options="userNameInput.options" :data="userNameInput.data"/>
                    </CCol>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput :options="passwordInput.options" :data="passwordInput.data"/>
                    </CCol>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput :options="fullNameInput.options" :data="fullNameInput.data"/>
                    </CCol>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput :options="phoneInput.options" :data="phoneInput.data"/>
                    </CCol>
                    <CCol sm="6" md="6" xl="6">
                      <BaseInput :options="emailInput.options" :data="emailInput.data"/>
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton
                  color="primary"
                  class="btn-action-primary mr-2"
                  @click="submitData()"
                >
                  <i class="fa fa-save"></i>&nbsp;Lưu lại
                </CButton
                >
                <CButton
                  color="secondary"
                  class="btn-action-primary"
                  @click="$router.go(-1)"
                ><i class="fa fa-reply"></i>&nbsp;Hủy bỏ
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";
import Multiselect from "vue-multiselect";
import {Authorities, PROVINCE_CODE} from "@/constant";

export default {
  name: "UserAdd",
  components: {BaseSelect, BaseInput, BaseLoading, Multiselect},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      locationManagementSelected: {
        options: [],
        data: {
          name: "locationManagement",
          model: "",
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.locationManagementSelected.data.model;
              if (value === "" || that.locationManagementSelected.data.model.length == 0) {
                this.isValid = false;
                this.errorMessage = "Địa bàn quản lý không được để trống";
              } else if (that.rolesSelect.data.model == Authorities.ROLE_MANAGEMENT
                  && that.locationSelect.data.model
                  && !that.locationManagementSelected.data.model.find(obj => obj.key == that.locationSelect.data.model)) {
                this.isValid = false;
                this.errorMessage = "Địa bàn quản lý phải có địa bàn mặc định của tài khoản";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      /* Username */
      userNameInput: {
        options: {
          label: "Tên đăng nhập <span class='required'>*</span>",
          placeholder: "Tên đăng nhập",
          type: "text",
          // append: 'N/A'
        },
        data: {
          name: "username",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.userNameInput.data.model;
              // let username_regex = /^([a-zA-Z0-9!%&@#$^*_]){6,}$/;
              let username_regex = /^([a-zA-Z0-9_.]){6,100}$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tên đăng nhập không được để trống";
              } else if (username_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Tên đăng nhập sai định dạng, tối thiểu 6 kí tự";
              } else if (username_regex.test(value) == true) {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      /* Password */
      passwordInput: {
        options: {
          label: "Mật khẩu <span class='required'>*</span>",
          placeholder: "Mật khẩu",
          type: "password"
        },
        data: {
          name: "password",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.passwordInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Mật khẩu không được để trống";
              } else if (!that.$helper.isValidPasswordFormat(value)) {
                this.isValid = false;
                this.errorMessage = "Mật khẩu sai định dạng";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      /* Phone */
      phoneInput: {
        options: {
          label: "Số điện thoại <span class='required'>*</span>",
          placeholder: "Số điện thoại",
          type: "number"
        },
        data: {
          name: "phone",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.phoneInput.data.model;
              let phone_regex = /^(0[3|5|7|8|9])+([0-9]{8})$/
              let phone_regex2 = /^(84[3|5|7|8|9])+([0-9]{8})$/
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Số điện thoại không được để trống";
              } else if (phone_regex.test(value) == false && phone_regex2.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Số điện thoại sai định dạng";
              } else if (phone_regex.test(value) == true || phone_regex2.test(value) == true) {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      /* Address */
      addressInput: {
        options: {
          label: "Địa chỉ <span class='required'>*</span>",
          placeholder: "Địa chỉ",
        },
        data: {
          name: "address",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.addressInput.data.model;
               if (value.length > 128) {
                this.isValid = false;
                this.errorMessage = "Địa chỉ không được quá 128 kí tự";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      /* Role */
      rolesSelect: {
        options: {
          label: "Nhóm người dùng tài khoản <span class='required'>*</span>",
          selectAllText: "Chọn nhóm người dùng tài khoản",
          filter: false,
          'keyField': 'value',
          'valueField': 'text',
        },
        data: {
          model: "",
          name: 'role',
          source: {
            url: "/role/listRole",
            response: function (dataResponse) {
              return dataResponse.data;
            }
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.rolesSelect.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Nhóm người dùng không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          },
        }
      },
      /* Location */
      locationSelect: {
        options: {
          lazyLoad: true,
          label: "Địa phương tài khoản <span class='required'>*</span>",
          selectAllText: "Chọn địa phương",
          'keyField': 'key',
          'valueField': 'value',
          disabled: true,
        },
        data: {
          model: "",
          name: 'locationCode',
          items: [],
          source: {
            url: "/common/findAllLocationByLevel",
            isJsonContentType: false,
            dataSubmit() {
              let _level = 0;
              if (that.rolesSelect.data.model == Authorities.ROLE_DISTRICT) {
                _level = 1;
              } else if (that.rolesSelect.data.model == Authorities.ROLE_WARD) {
                _level = 2;
              } else if (that.rolesSelect.data.model == Authorities.ROLE_VILLAGE) {
                _level = 3;
              }
              return {
                level: _level,
              }
            },
            response: function (dataResponse) {
              that.locationSelect.data.items = dataResponse.data;
              if(that.rolesSelect.data.model == Authorities.ROLE_PROVINCE
                  || that.rolesSelect.data.model == Authorities.ROLE_MANAGEMENT) {
                if(dataResponse.data && dataResponse.data[0]) {
                  that.locationSelect.data.model = dataResponse.data[0].key;

                  if(that.rolesSelect.data.model == Authorities.ROLE_MANAGEMENT) {
                    if(!that.locationManagementSelected.data.model) {
                      that.locationManagementSelected.data.model = [];
                    }
                    if(!that.locationManagementSelected.data.model.find(obj => obj.key == dataResponse.data[0].key)) {
                      that.locationManagementSelected.data.model.push(dataResponse.data[0]);
                    }
                  }
                }
              }
            }
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.locationSelect.data.model;
              let roleValue = that.rolesSelect.data.model;
              if (value === "" && (roleValue && roleValue != Authorities.ROLE_ADMIN && roleValue != Authorities.ROLE_PROVINCE && roleValue != Authorities.ROLE_MANAGEMENT && roleValue != Authorities.ROLE_SYNCHRONIZE && roleValue != Authorities.ROLE_MANAGEMENT_DEVICE)) {
                this.isValid = false;
                this.errorMessage = "Địa phương không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          },
        }
      },
      /* Email */
      emailInput: {
        options: {
          label: "Email <span class='required'>*</span>",
          placeholder: "Email",
        },
        data: {
          name: "email",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.emailInput.data.model;
              let email_regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Email không được để trống";
              } else if (email_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Email không đúng định dạng";
              } else if (email_regex.test(value) == true) {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      /* FullName */
      fullNameInput: {
        options: {
          label: "Họ Tên <span class='required'>*</span>",
          placeholder: "Họ và tên",
        },
        data: {
          name: "fullName",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.fullNameInput.data.model;
              let fullname_regex = /^[a-zA-Z_ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀẾỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪếễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựýỳỵỷỹ ]+$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Họ và tên không được để trống";
              } else if (fullname_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Họ và tên không đúng định dạng";
              } else if (fullname_regex.test(value) == true) {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
    }
  },
  methods: {
    loadDataManagementLocation(level) {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/common/find-all-location-by-level",
        ignoreDefaultData: true,
        isJsonContentType: false,
        dataSubmit() {
          return {
            level: level == null ? 0 : level,
          }
        },
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.locationManagementSelected.options = response.data.data || [];
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= this.userNameInput.data.validator.valid();
      isValid &= this.passwordInput.data.validator.valid();
      isValid &= this.rolesSelect.data.validator.valid();
      isValid &= this.locationSelect.data.validator.valid();
      isValid &= this.phoneInput.data.validator.valid();
      isValid &= this.emailInput.data.validator.valid();
      isValid &= this.addressInput.data.validator.valid();
      isValid &= this.fullNameInput.data.validator.valid();
      var locationManagement = null;
      if(this.rolesSelect.data.model == Authorities.ROLE_MANAGEMENT
          || this.rolesSelect.data.model == Authorities.ROLE_MANAGEMENT_DEVICE) {
        isValid &= this.locationManagementSelected.data.validator.valid();
        if (this.locationManagementSelected.data.model.length > 0) {
          locationManagement = [];
          for (let i = 0; i < this.locationManagementSelected.data.model.length; i++) {
            locationManagement.push(this.locationManagementSelected.data.model[i].key);
          }
        }
      }
      if (!isValid) {
        return;
      }
      let locationCode = (this.rolesSelect.data.model == Authorities.ROLE_ADMIN
        || this.rolesSelect.data.model == Authorities.ROLE_PROVINCE) ? PROVINCE_CODE : this.locationSelect.data.model;
      let dataRequest = {
        // username: `${this.userNameInput.data.model}_${locationCode}`,
        username: `${this.userNameInput.data.model}`,
        password: this.passwordInput.data.model,
        role: this.rolesSelect.data.model,
        locationCode: locationCode,
        phone: this.phoneInput.data.model,
        email: this.emailInput.data.model,
        address: this.addressInput.data.model,
        fullName: this.fullNameInput.data.model,
        locationManagement: locationManagement
      }
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/users/addUser",
        dataSubmit: function () {
          return dataRequest;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Thêm mới tài khoản thành công"
            });
            that.$router.go(-1);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  },
  computed: {},
  created() {
    this.loadDataManagementLocation(0);
  },
  mounted() {
  },
  watch: {
    'rolesSelect.data.model': function (value) {
      if (value == Authorities.ROLE_MANAGEMENT) {
        this.locationManagementSelected.data.model = [];
        this.loadDataManagementLocation(0);
      } else if (value == Authorities.ROLE_MANAGEMENT_DEVICE) {
        this.locationManagementSelected.data.model = [];
        this.loadDataManagementLocation(2);
      }
      if (value == Authorities.ROLE_DISTRICT || value == Authorities.ROLE_WARD || value == Authorities.ROLE_VILLAGE) {
        this.$refs.locationSelect.loadData();
        this.locationSelect.options.disabled = false;
        // this.userNameInput.options.append = 'N/A';
      } else {
        // this.userNameInput.options.append = `_${PROVINCE_CODE}`;
        this.$refs.locationSelect.loadData();
        this.locationSelect.options.disabled = true;
        // setTimeout(function() {
        //   if(this.locationSelect.data.items[0]) {
        //     this.addressInput.data.model = this.locationSelect.data.items[0].value;
        //   }
        // }, 500)
        
      }
      this.rolesSelect.data.validator.valid();
      this.locationSelect.data.validator.valid();
    },
    'locationSelect.data.model': function (value) {
      if (this.rolesSelect.data.model == Authorities.ROLE_ADMIN || this.rolesSelect.data.model == Authorities.ROLE_PROVINCE) {
        // this.userNameInput.options.append = `_${PROVINCE_CODE}`;
        // this.addressInput.data.model = this.$refs.locationSelect.getTextSelected;
      } else {
        if (value && value != undefined) {
          // this.userNameInput.options.append = `_${value}`;
          this.addressInput.data.model = this.$refs.locationSelect.getTextSelected;
        } else {
          // this.userNameInput.options.append = 'N/A';
        }
        this.locationSelect.data.validator.valid();
      }
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>